import { React, useState } from "react";
import { ListItemText, ListItem, ListItemIcon, Popover } from "@mui/material";
import {
	DeleteOutlineOutlined,
	InsertEmoticon,
	EditOutlined,
} from "@mui/icons-material";
import "./CategoryList.scss";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import {
	useEditSubcategoryMutation,
	useCategoriesQuery,
} from "../../services/queryHooks";
import DeleteSubcategoryModal from "./modals/DeleteSubcategoryModal";
import EditSubcategoryModal from "./modals/EditSubcategoryModal";
import { useTranslation } from "react-i18next";

export default function SubcategoryList({
	categoryGroupId,
	subcategory,
	type,
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedIndex, setSelectedIndex] = useState(null);
	const [isCategoryEditOn, setIsCategoryEditOn] = useState(false);
	const [isDeleteModalOn, setIsDeleteModalOn] = useState(false);

	const editSubcategoryMutation = useEditSubcategoryMutation();
	const { data: categories } = useCategoriesQuery();
	const { t } = useTranslation();

	const handleClick = (event, id) => {
		setAnchorEl(event.currentTarget);
		setSelectedIndex(id);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleEmojiSelect = (emoji) => {
		editSubcategoryMutation.mutate({
			categoryGroupId,
			subcategoryId: selectedIndex,
			emoji: emoji.native,
		});
		setSelectedIndex(null);
		handleClose();
	};

	return (
		<>
			<ListItem sx={{ pl: 1, py: 0 }} key={subcategory._id}>
				<ListItemIcon
					sx={{
						cursor: "pointer",
						minWidth: "auto",
						color: "inherit",
						mr: 1,
					}}
					onClick={(e) => handleClick(e, subcategory._id)}
				>
					{subcategory.emoji ? (
						<span style={{ fontSize: 22, color: "null" }}>
							{subcategory.emoji}
						</span>
					) : (
						<InsertEmoticon
							className="hover"
							sx={{ width: "30.36px" }}
						/>
					)}
				</ListItemIcon>
				<ListItemText
					primary={
						subcategory.name
							? subcategory.name
							: t(subcategory.translationKey)
					}
				/>
				<ListItemIcon
					sx={{ minWidth: "auto", ml: 1 }}
					onClick={() => setIsCategoryEditOn(true)}
				>
					<EditOutlined className="hover" />
				</ListItemIcon>
				<ListItemIcon
					sx={{ minWidth: "auto", ml: 1 }}
					onClick={() => setIsDeleteModalOn(true)}
				>
					<DeleteOutlineOutlined className="hover" />
				</ListItemIcon>
			</ListItem>
			<Popover
				disableEnforceFocus
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			>
				<Picker
					data={data}
					onEmojiSelect={handleEmojiSelect}
					previewPosition="none"
				/>
			</Popover>
			<EditSubcategoryModal
				isOpen={isCategoryEditOn}
				onClose={() => setIsCategoryEditOn(false)}
				categoryGroupId={categoryGroupId}
				subcategory={subcategory}
			/>
			<DeleteSubcategoryModal
				isOpen={isDeleteModalOn}
				categoryGroupId={categoryGroupId}
				categoryType={type}
				subcategory={subcategory}
				categories={categories}
				onClose={() => setIsDeleteModalOn(false)}
			/>
		</>
	);
}
